var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "新增",
        visible: _vm.dialogVisible,
        width: "800px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("中文名"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "userRoleNameCH" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入中文名" },
                        model: {
                          value: _vm.form.userRoleNameCH,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userRoleNameCH", $$v)
                          },
                          expression: "form.userRoleNameCH",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }),
                    _vm._v("英文名"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "userRoleNameEN" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入英文名" },
                        model: {
                          value: _vm.form.userRoleNameEN,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userRoleNameEN", $$v)
                          },
                          expression: "form.userRoleNameEN",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("状态"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "isActived" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": " rgb(18,88,188)",
                          "inactive-color": "#f1f1f1",
                        },
                        model: {
                          value: _vm.form.isActived,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isActived", $$v)
                          },
                          expression: "form.isActived",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }